import {
  GroupRowType,
  GroupTableType,
  LayerGroupType,
  RV
} from "helpers/models";
import getColor from "report/common/color-rule";
import sortArray from "report/common/sort-lable-fathom";
import sortLayerBottom from "./sort-layer-bottom";

const transform = (group: RV, legend: LayerGroupType): GroupTableType => {
  const integratedData: GroupTableType = {};

  Object.keys(group).forEach((layer) => {
    integratedData[layer] = [];

    const otherArray = sortLayerBottom(Object.keys(legend[layer]).reverse());
    const orderArray = layer.includes("Fathom") ? sortArray : otherArray;
    const arrayToSort = Object.keys(group[layer]);
    arrayToSort.sort((a: string, b: string) => {
      return orderArray.indexOf(a) - orderArray.indexOf(b);
    });

    arrayToSort.forEach((key: string) => {
      integratedData[layer].push({
        label: key,
        count: group[layer][key],
        color: getColor(key, legend[layer])
      });
    });

    // integratedData[layer].sort((a: GroupRowType, b: GroupRowType) => {
    //   return sortArray.indexOf(a.label) - sortArray.indexOf(b.label);
    // });
  });

  return integratedData;
};

export default transform;
